import { REGEX_PHONE_NUMBER, SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const loginValidationSchema = Yup.object().shape({
  email: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  password: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});

export const signUpValidationSchema = Yup.object().shape({
  fullName: Yup.string().required(SystemMessage.FULL_NAME_REQUIRED),
  phone: Yup.string()
    .required(SystemMessage.INPUT_REQUIRED)
    .matches(REGEX_PHONE_NUMBER, SystemMessage.PHONE_INVALID),
  username: Yup.string()
    .required(SystemMessage.USERNAME_REQUIRED)
    .matches(/^[a-zA-Z0-9]+$/, SystemMessage.USERNAME_INVALID),
  email: Yup.string()
    .required(SystemMessage.INPUT_REQUIRED)
    .email(SystemMessage.EMAIL_ADDRESS_INVALID),
  password: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  confirmPassword: Yup.string()
    .required(SystemMessage.CONFIRM_PASSWORD_REQUIRED)
    .oneOf([Yup.ref("password")], SystemMessage.CONFIRM_PASSWORD_INVALID),
  agree: Yup.array().min(1, SystemMessage.AGREE_TERMS_REQUIRED),
});
